const C = require("../constants");

const ingredientDialog = (data) => {
    return {
        type: C.INGREDIENT_DIALOG,
        data
    }
};

export {ingredientDialog};


// WEBPACK FOOTER //
// ./src/actions/IngredientDialogAction.js